import React from "react"

const Teams = () => {
  return <div>teams</div>
}

export default Teams
